
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.774 17.358L12.946 4.88C12.644 4.329 12.104 4 11.5 4s-1.144.33-1.446.88L3.226 17.359a1.826 1.826 0 000 1.761c.302.552.843.881 1.446.881h13.656c.603 0 1.144-.33 1.446-.88a1.827 1.827 0 000-1.762zm-8.274.612c-.6 0-1.087-.514-1.087-1.146 0-.633.488-1.147 1.087-1.147.6 0 1.087.514 1.087 1.147 0 .632-.488 1.146-1.087 1.146zm1.094-4.9c0 .636-.49 1.153-1.094 1.153-.603 0-1.094-.517-1.094-1.154V7.772c0-.302.232-.547.518-.547h1.152c.286 0 .518.245.518.547v5.297z","fill-rule":"nonzero"}})])
          )
        }
      }
    